import { AppTFunction } from '@retail/app/i18n';
import * as yup from 'yup';

export const priceSchema = (t: AppTFunction) =>
  yup
    .number()
    .required(t('calculus.error.requiredField'))
    .typeError(t('calculus.error.mustBeNumberOver0'))
    .transform((_, value: string | null) => {
      if (value) {
        return Number((value + '').replace(',', '.'));
      }
      return undefined;
    })
    .positive(t('calculus.error.mustBeNumberOver0'))
    .test('max-two-decimals', t('calculus.error.mustHaveMaxTwoDecimalsSimple'), (value) => {
      if (value === undefined || value === null) return true;
      const stringValue = value.toString();
      const decimalPart = stringValue.split('.')[1];
      return !decimalPart || decimalPart.length <= 2;
    });

export const salesPriceSchema = (t: AppTFunction) => yup.object({ salesPrice: priceSchema(t) });
export const purchasePriceSchema = (t: AppTFunction) =>
  yup.object({ purchasePrice: priceSchema(t) });

export type SalesPriceSchema = yup.InferType<ReturnType<typeof salesPriceSchema>>;
export type PurchasePriceSchema = yup.InferType<ReturnType<typeof purchasePriceSchema>>;

export const purchasePeriodSchema = (t: AppTFunction) =>
  yup.object({
    purchasePeriodFrom: yup
      .date()
      .required(t('campaign.error.requiredField'))
      .when('purchasePeriodTo', (purchasePeriodTo, schema) =>
        purchasePeriodTo && purchasePeriodTo.toString() !== 'Invalid Date'
          ? schema.max(purchasePeriodTo, t('campaign.error.dateMustBeBeforeTo'))
          : schema
      ),
    purchasePeriodTo: yup.date().required(t('campaign.error.requiredField')),
  });

export type PurchasePeriodSchema = yup.InferType<ReturnType<typeof purchasePeriodSchema>>;
